import { GraphQLResult } from 'aws-amplify/api';
import { DeleteCaseClusterMutation } from '@/services/API';
import { deleteCaseCluster } from '@/services/graphql/mutations';
import { actions } from '@/store/slices/caseCluster';
import { AppDispatch } from '@/store/Store';
import { callGraphQLApi } from '@/utils/graphQLAPI';
import { fetchCaseClusterList } from './fetchCaseClusterList';

export function deleteACaseCluster(caseClusterID: string) {
  return async (dispatch: AppDispatch) => {
    const input = {
      id: caseClusterID,
    };
    try {
      await callGraphQLApi<GraphQLResult<DeleteCaseClusterMutation>>(deleteCaseCluster, {
        input,
      });
      dispatch(fetchCaseClusterList());
    } catch (error) {
      dispatch(actions.setError(error));
    }
  };
}
